import { render } from "./BaseBadge.vue?vue&type=template&id=49f8d71c&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=49f8d71c&scoped=true&lang=css"

import exportComponent from "D:\\vue-js\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f8d71c"]])

export default __exports__